import React, { useState } from 'react';
import { Typography, theme } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { primaryShades } from '../../theme/theme';
import ButtonsComponent from './MainComponents/ButtonsComponent';
import MessageSection from './Modals/MessageSection';
import HeaderComponent from './Headers/HeaderComponent';
import CustomCard from './Cards/CustomCard';
import CatalogueCard from './Cards/CatalogueCard';
import AssetMonitorItem from './Cards/AssetMonitorItem';
import SummaryCard from './Cards/SummaryCard';
import ComparisonCard from './Cards/ComparisonCard';
import LoadingCard from './Cards/LoadingCard';
import SimpleChart from './Charts/SimpleChart';
import { SingleDatePickerComponent, RangePickerComponent } from './MainComponents/DatePickerComponent';
import FilterComponent from './Filters/FilterComponent';
import ModalSection from './MainComponents/ModalSection';
import SimpleCard from './Cards/SimpleCard';
const { Title, Text } = Typography;
const { useToken } = theme;

// Costanti dei colori
const PRIMARY_300 = primaryShades.primary300;
const PRIMARY_500 = primaryShades.primary500;
const PRIMARY_700 = primaryShades.primary700;

const handleCreateReport = () => {
    console.log('Create report button clicked');
    // Implementare la logica per creare il report
};

const ComponentsManager = () => {
    const { token } = useToken();

    // Date picker states
    const [selectedDate, setSelectedDate] = useState(null);
    const [dateRange, setDateRange] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleDateRangeChange = (dates) => {
        setDateRange(dates);
    };

    return (
        <div>
            {/* Header Component */}
            <div>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Header</Title>
                <SimpleCard>
                    <HeaderComponent
                        title="Gateways - Analytics"
                        buttonText="Create your report"
                        onButtonClick={handleCreateReport}
                        useSpaceBetween={false}
                        isVisible={true}
                    />
                </SimpleCard>
            </div>

            {/* Buttons Component */}
            <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Buttons</Title>
            <SimpleCard>
                <ButtonsComponent />
            </SimpleCard>

            {/* Custom Card Component */}
            <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Custom Card</Title>
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)', display: 'flex', gap: 'clamp(0.625rem, 2vw, 1.25rem)', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', minWidth: 'clamp(15.625rem, 30vw, 18.75rem)' }}>
                    <CustomCard
                        title="Informazioni Utente"
                        icon={<InfoCircleOutlined />}
                        height="clamp(9.375rem, 20vw, 12.5rem)"
                        tooltipText="Informazioni dettagliate sull'utente"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                            <Text style={{ fontSize: 'clamp(0.875rem, 1.6vw, 1rem)', marginBottom: 'clamp(0.3125rem, 1vw, 0.625rem)' }}>Nome: Mario Rossi</Text>
                            <Text style={{ fontSize: 'clamp(0.875rem, 1.6vw, 1rem)', marginBottom: 'clamp(0.3125rem, 1vw, 0.625rem)' }}>Email: mario.rossi@example.com</Text>
                            <Text style={{ fontSize: 'clamp(0.875rem, 1.6vw, 1rem)' }}>Ruolo: Amministratore</Text>
                        </div>
                    </CustomCard>
                </div>
                <div style={{ flex: '1', minWidth: 'clamp(15.625rem, 30vw, 18.75rem)' }}>
                    <CustomCard
                        title="Statistiche Recenti"
                        headerColor={PRIMARY_300}
                        textColor={PRIMARY_700}
                        height="clamp(9.375rem, 20vw, 12.5rem)"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                            <Text style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 'bold', color: PRIMARY_500, marginBottom: 'clamp(0.1875rem, 0.5vw, 0.3125rem)' }}>1,234</Text>
                            <Text style={{ fontSize: 'clamp(0.75rem, 1.4vw, 0.875rem)', color: PRIMARY_500 }}>VISUALIZZAZIONI TOTALI</Text>
                        </div>
                    </CustomCard>
                </div>
            </div>

            <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Modal Box</Title>
            <SimpleCard>
                <ModalSection />
            </SimpleCard>

            <Title level={3} style={{ color: PRIMARY_700, textAlign: 'left' }}>Messages</Title>
            <SimpleCard>
                <MessageSection />
            </SimpleCard>

            {/* Date Picker Components */}
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)' }}>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Date Pickers</Title>

                <div style={{ display: 'flex', gap: 'clamp(0.9375rem, 2.5vw, 1.875rem)', flexWrap: 'wrap' }}>
                    {/* Single Date Picker */}
                    <div style={{ flex: '1', minWidth: 'clamp(15.625rem, 30vw, 18.75rem)' }}>
                        <SimpleCard title="Single Date Picker">

                            <SingleDatePickerComponent
                                value={selectedDate}
                                onChange={handleDateChange}
                            />

                            <div style={{ marginTop: 'clamp(0.625rem, 2vw, 1.25rem)' }}>
                                <Text type="secondary">Selected date: {selectedDate ? selectedDate.format('DD/MM/YYYY') : 'None'}</Text>
                            </div>
                        </SimpleCard>
                    </div>

                    {/* Date Range Picker */}
                    <div style={{ flex: '1', minWidth: 'clamp(15.625rem, 30vw, 18.75rem)' }}>
                        <SimpleCard title="Date Range Picker">
                            <RangePickerComponent
                                value={dateRange}
                                onChange={handleDateRangeChange}
                            />

                            <div style={{ marginTop: 'clamp(0.625rem, 2vw, 1.25rem)' }}>
                                <Text type="secondary">
                                    Date range: {dateRange ?
                                        `${dateRange[0].format('DD/MM/YYYY')} - ${dateRange[1].format('DD/MM/YYYY')}` :
                                        'None'}
                                </Text>
                            </div>
                        </SimpleCard>
                    </div>
                </div>
            </div>

            {/* Filter Component */}
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)' }}>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Filter Component</Title>
                <SimpleCard>
                    <FilterComponent />
                </SimpleCard>
            </div>

            {/* Catalogue Monitor Section */}
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)' }}>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Featured Box</Title>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ width: '20%' }}>
                        <CatalogueCard />
                    </div>
                    <div style={{ width: '20%' }}>
                        <CatalogueCard
                            title="SUMMER TOUR"
                            assetCount={212}
                        />
                    </div>
                    <div style={{ width: '20%' }}>
                        <CatalogueCard
                            title="SMITH OPTICS"
                            assetCount={46}
                            badgeCount={2}
                        />
                    </div>
                    <div style={{ width: '20%' }}>
                        <CatalogueCard
                            title="BOSS EYEWEAR"
                            assetCount={117}
                        />
                    </div>
                </div>
            </div>

            {/* Asset Monitor Section */}
            <div>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Info Box</Title>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div style={{ width: '20%', padding: '0' }}>
                        <AssetMonitorItem
                            count="2544"
                            label="TOTAL 3D ASSETS"
                            isFirst={true}
                        />
                    </div>
                    <div style={{ width: '20%', padding: '0' }}>
                        <AssetMonitorItem
                            count="679"
                            label="MAIN 3D ASSETS"
                        />
                    </div>
                    <div style={{ width: '20%', padding: '0' }}>
                        <AssetMonitorItem
                            count="2138"
                            label="PUBLISHED"
                            sublabel="3D ASSETS"
                        />
                    </div>
                    <div style={{ width: '20%', padding: '0' }}>
                        <AssetMonitorItem
                            count="144"
                            label="TO BE VALIDATED"
                            sublabel="3D ASSETS"
                            badgeCount={2}
                        />
                    </div>
                    <div style={{ width: '20%', padding: '0' }}>
                        <AssetMonitorItem
                            count="110"
                            label="IN THE MAKING"
                            sublabel="3D ASSETS"
                            color={token.colorPrimary}
                            isLast={true}
                        />
                    </div>
                </div>
            </div>

            {/* KPI Section */}
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)' }}>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Details Box</Title>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}>
                    {/* Colonna sinistra */}
                    <div style={{ width: '20%' }}>
                        <SummaryCard
                            title="Number of users (last 7 days)"
                            value="3307"
                            subtitle="TOTAL USER"
                        />
                        <ComparisonCard
                            title="Gap between previous week"
                            value="1003"
                            subtitle="TOTAL USER"
                            isPositive={true}
                        />
                    </div>

                    {/* Grafico centrale */}
                    <div style={{ width: '58%', margin: '0 1%' }}>
                        <SimpleChart />
                    </div>

                    {/* Colonna destra */}
                    <div style={{ width: '20%' }}>
                        <SummaryCard
                            title="Number of sessions (last 7 days)"
                            value="6143"
                            subtitle="TOTAL SESSIONS"
                        />
                        <ComparisonCard
                            title="Gap between previous week"
                            value="-13%"
                            subtitle="TOTAL SESSIONS"
                            isPositive={false}
                        />
                    </div>
                </div>
            </div>

            {/* Loading Card Section */}
            <div style={{ marginBottom: 'clamp(1.25rem, 3vw, 2.5rem)' }}>
                <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Loading Card</Title>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ width: '30%' }}>
                        <LoadingCard />
                    </div>
                    <div style={{ width: '30%' }}>
                        <LoadingCard
                            size="small"
                            message="Caricamento dati..."
                        />
                    </div>
                    <div style={{ width: '30%', height: '200px' }}>
                        <LoadingCard
                            height="200px"
                            message="Caricamento grafico..."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComponentsManager; 